module.exports = __webpack_public_path__ + "img/success.d50ba45a.jpg";